import { render } from "./RedirectPatient.vue?vue&type=template&id=7d915ffe&scoped=true"
import script from "./RedirectPatient.vue?vue&type=script&lang=js"
export * from "./RedirectPatient.vue?vue&type=script&lang=js"

import "./RedirectPatient.vue?vue&type=style&index=0&id=7d915ffe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d915ffe"]])

export default __exports__